import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {first} from 'rxjs';
import {environment} from '../../../../../../environments/environment';
import {ProfileService} from '../../../services/profile.service';
import {BranchService} from '../../../services/branch.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit{

  userForm: FormGroup;
  branches: any[] = [];
  profiles: any[] = [];
  branchSelected: number | undefined;
  profileSelected: number | undefined;
  saving = false;

  loadForm = true;

  public data: any;
  id: number;
  profileName: string;
  userName: string;

  private baseUploadUrl = environment.apiBaseUrlUpload;

  defaultImg: string;
  isSubmitted = false;
  fileHad: File = null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private userService: UserService,
              private profileService: ProfileService,
              private branchService: BranchService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public route: Router,
              public router: ActivatedRoute
  ) {
    this.userForm = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern(/^((?!672)\d{9}|672\d{6})$/)]],
      email: ['', [Validators.email]],
      username: ['', [Validators.required]],
      file: '',
      fileSource: '',
      branch: ['', [Validators.required]],
      profile: ['', [Validators.required]],
      isNetworkManager: 0,
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.userForm.get('isEnable')?.setValue('1');
    this.id = this.router.snapshot.params.id;
    this.userForm.patchValue(this.data);
    this.findBranches();
    this.findProfiles();
    // this.loadForm = true;

    if (this.id){
      this.userService.get(this.id)
          .pipe(first())
          .subscribe(x => {
            console.log(x);
            this.userForm.patchValue(x);
            this.branchSelected = x.branch['@id'];
            this.profileSelected = x.profile['@id'];
            this.userForm.get('isNetworkManager')?.setValue(x.isNetworkManager ? '1' : '0');
            this.profileName = x.profile.name;
            this.userName = x.username;
            this.defaultImg = x.picture;

            console.log(this.loadForm);
            this.userForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');
            this.loadForm = false;
          } );
    }
  }

  get fc(): any {
    return this.userForm.controls;
  }

  onChange(event): void{
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.fileHad = inputElement.files[0];
      this.userForm.patchValue({fileSource: this.fileHad});
      console.log(this.fileHad.name);
      // this.defaultImg = this.baseUploadUrl + 'uploads/' + this.fileHad.name;
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.defaultImg = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    // if (this.userForm.valid && this.fileHad && this.fileHad.name){
    if (this.userForm.valid){
      this.saving = true;
      if (this.id){
        console.log('hello maoll');

        const formData = new FormData();
        console.log(this.userForm.get('fileSource'));
        console.log(this.userForm.get('fileSource')?.value.type);
        console.log(this.userForm.get('firstname')?.value);
        formData.append('firstname', this.userForm.get('firstname')?.value);
        formData.append('lastname', this.userForm.get('lastname')?.value);
        formData.append('phone', this.userForm.get('phone')?.value);
        formData.append('email', this.userForm.get('email')?.value);
        formData.append('username', this.userForm.get('username')?.value);
        formData.append('branch', this.userForm.get('branch')?.value);
        formData.append('profile', this.userForm.get('profile')?.value);
        formData.append('isNetworkManager', this.userForm.get('isNetworkManager')?.value);
        formData.append('isEnable', this.userForm.get('isEnable')?.value);
        formData.append('file', this.userForm.get('fileSource')?.value);
        formData.append('fileName', this.userForm.get('fileSource')?.value.name);
        formData.append('fileSize', this.userForm.get('fileSource')?.value.size);
        formData.append('fileType', this.userForm.get('fileSource')?.value.type);

        console.log(formData);
        this.userForm.get('isEnable')?.setValue(this.userForm.get('isEnable')?.value === '1');
        this.userService.edit(this.id, formData).subscribe({
          next: (val: any) => {
            this.toastr.success(this.translate.instant('user') + ' ' + this.translate.instant('edited') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.route.navigate(['/security/user']);

            // this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err['hydra:description']);

            this.saving = false;
            this.isSubmitted = false;

            if (err['hydra:code'] == 400){
                this.toastr.error(this.translate.instant('This phone already exists.'))
            }  if (err['hydra:code'] == 401){
                this.toastr.error(this.translate.instant('This username already exists.'))
            } 

            const errors: any[] = err;
            console.log(errors);

            // if (errors.violations){
            //   errors.violations.forEach((v) =>
            //   {
            //     if (v.propertyPath === 'firstname'){
            //       this.userForm.get('firstname')?.setErrors({serverError: v.message});
            //     }
            //     if (v.propertyPath === 'lastname'){
            //       this.userForm.get('lastname')?.setErrors({serverError: v.message});
            //     }
            //     if (v.propertyPath === 'phone'){
            //       this.userForm.get('phone')?.setErrors({serverError: v.message});
            //     }
            //     if (v.propertyPath === 'email'){
            //       this.userForm.get('email')?.setErrors({serverError: v.message});
            //     }
            //     if (v.propertyPath === 'username'){
            //       this.userForm.get('username')?.setErrors({serverError: v.message});
            //     }
            //     if (v.propertyPath === 'password'){
            //       this.userForm.get('password')?.setErrors({serverError: v.message});
            //     }
            //     this.saving = false;

            //   });
            // }else {

            //   this.toastr.success(errors['hydra:description'], 'Success');

            // }

          }
        });
      }

    }
  }

  findBranches(): any{
    this.branchService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.branches = data['hydra:member'];
          this.branches = this.branches.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }

  findProfiles(): any{
    this.profileService.getCollection().subscribe((data: any) => {
          console.log(data['hydra:member']);
          this.profiles = data['hydra:member'];
          this.profiles = this.profiles.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }

}
